let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";